export default __webpack_public_path__ + "static/media/mastro.0a8d17a9.png";